define('v3/Common/Services/Frontend/Dialog.Service',[
	'jquery',
	'knockout',
	'lodash',
	'module',
	'v3/Common/Services/Frontend/Modal.Service'
], function ($, ko, _, module, modal) {
	var defaults = {
		modalClass: 'modal dialog',
		template: $('<div/>').addClass('modal-content'),
		content: false,
		title: '',
		icon: 'Alert'
	};

	var getOptions = function () {
		var options = $.extend({}, defaults);

		if (!_.isPlainObject(arguments[0])) {
			options.title = arguments[1] || '';
			options.content = arguments[0] || false;
			options.buttons = (arguments[2] && arguments[2].length) ? arguments[2] : [Strings.YesButton, Strings.CancelButton];
		} else {
			options = $.extend({}, defaults, arguments[0]);
			options.title = options.title || '';
			options.content = options.content || false;
			options.buttons = options.buttons || [Strings.YesButton, Strings.CancelButton];
		}

		return options;
	};

	function Dialog () { }

	$.extend(Dialog.prototype, {

		confirm: function () {
			var option = getOptions.apply(modal, arguments);
			option.modalClass = option.modalClass + ' confirm';
			return modal(option);
		},

		alert: function () {
			var option = getOptions.apply(modal, arguments);
			option.modalClass = option.modalClass + ' alert';
			return modal(option);
		}

	});

	return new Dialog();
});

